import { Modal } from 'react-bootstrap';
import { useMemo } from 'react';
import PratusTable from 'components/DesignSystems/PratusTable/PratusTable';
import { ColumnDef } from '@tanstack/react-table';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { useWalaLog } from 'components/IAP/hooks/assignmentListHooks';
import dayjs from 'dayjs';
import type { ProposedStatusOption } from './AssignmentList';
import { mapProposedStatus } from './mapProposedStatus';

interface StatusChangeRow {
  timestamp: string;
  user: string;
  status: ProposedStatusOption;
}

const ChangeLogDialog: React.FC<{
  onClose: () => void;
  walaId: string;
}> = ({ onClose, walaId }) => {
  const { data: activityLog } = useWalaLog(walaId);

  const columns = useMemo<
    ColumnDef<{ timestamp: string; user: string; status: string }>[]
  >(
    () => [
      {
        id: 'status',
        header: 'Status',
        sortable: true,
        cell: ({ row }) => {
          const { status } = row.original;
          return status;
        },
      },
      {
        id: 'user',
        header: 'User',
        sortable: true,
        cell: ({ row }) => {
          const { user } = row.original;
          return user;
        },
      },
      {
        id: 'timestamp',
        header: 'Timestamp',
        sortable: true,
        cell: ({ row }) => {
          const { timestamp } = row.original;
          return timestamp;
        },
      },
    ],
    []
  );

  const data = useMemo<StatusChangeRow[]>(
    () =>
      activityLog?.map((entry) => ({
        timestamp: dayjs(entry.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
        user: entry.updatedByUserName || entry.updatedByEmail,
        status: mapProposedStatus(entry.proposedStatus, entry.status),
      })) || ([] as StatusChangeRow[]),

    [activityLog]
  );

  return (
    <Modal
      show={true}
      onHide={onClose}
      centered
      size="lg"
      backdrop={true}
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Change Log</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <PratusTable columns={columns} data={data} />

        <div className="d-flex justify-content-end mt-3">
          <StylishNewButton onClick={onClose}>Close</StylishNewButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeLogDialog;
